import DischargeScale from './DischargeScale';

class DischargeSequence {
  constructor(data = {}) {
    if (data.id) {
      this.id = data.id;
    }
    this.name = data.name || '';
    this.allWaterOnFirstDrop = data.allWaterOnFirstDrop || false;
    this.allWashWaterOnLastDrop = data.allWashWaterOnLastDrop || false;
    this.holdHeadWaterUntilAdmixFinish = data.holdHeadWaterUntilAdmixFinish || false;
    this.holdWashWaterUntilAdmixFinish = data.holdWashWaterUntilAdmixFinish || false;
    this.useDiscreteDischarge = data.useDiscreteDischarge || false;
    this.noFlowControl = data.noFlowControl || false;
    this.defaultFlowRate =  data.defaultFlowRate || 250;
    this.discharges = [];

    if (data.discharges?.length) {
      data.discharges.sort((x, y) => x.order - y.order);
      data.discharges.forEach(v => {
        this.discharges.push(new DischargeScale(v));
      });
    }
  }
}

export default DischargeSequence;
